import React, {useEffect, useState} from 'react';
import './NewArrival.css';
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa6";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import {Navigation, Pagination} from 'swiper/modules';
import { productsAPI } from '../../../Api/api';
import { useAppLanguage } from '../../../Hooks/useAppLanguage';
import ProductCard from '../../../Component/UI/ProductCard/ProductCard';
import Loaders from '../../../Component/UI/Loaders/Loaders';
import { productPlaceholder } from '../../../data/productPlaceholder';

function NewArrival() {
    const { t, langPath } = useAppLanguage();
    const [cardsData, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchItems = async () => {
            setLoading(true);
            try {
                const response = await productsAPI.getAll({
                    isNewItem: true,
                    limit: 24,
                    sortBy: 'createdAt',
                    sortOrder: 'desc',
                });
                const data = response.data || [];
                if (data.length === 0) {
                    setItems(productPlaceholder);
                } else {
                    setItems(data);
                }
            } catch (error) {
                console.error('Error fetching items:', error);
                setItems(productPlaceholder);
            } finally {
                setLoading(false);
            }
        };

        fetchItems();
    }, []);

    return (
        <main >
            <section
                className="new-arrival-container container"
                id="projects"
            >
                <div className='new-arrival-title-container container'>
                    <h2 className='popular-title section_title'>
                        {t('home.newArrival')}
                    </h2>
                    <Link to={langPath('/products')}>
                        <h3 className='section_subtitle'>
                            {t('home.allProducts')}
                            <FaArrowRight className='popular_title-arrow'/>
                        </h3>
                    </Link>
                </div>
                {loading ? (
                    <Loaders variant="newArrival" />
                ) : (
                <Swiper
                    style={{
                        "--swiper-navigation-color": "var(--first-color)",
                        "--swiper-pagination-color": "var(--first-color)",
                    }}

                    spaceBetween={5}

                    breakpoints={{
                        300: {
                            slidesPerView: 1,
                            spaceBetween: 5,
                        },
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 10,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 15,
                        },
                        1000: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        }
                    }}
                    navigation={{
                        clickable: true,
                    }}
                    pagination={{
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 5,
                    }}
                    modules={[Pagination, Navigation]}
                    className="new-arrival-swiper swiper-container"
                >
                    {cardsData.map((product) => (
                        <SwiperSlide key={product._id}>
                            <ProductCard product={product} />
                        </SwiperSlide>
                    ))}
                </Swiper>
                )}
            </section>
        </main>
    );
}

export default NewArrival;
